import { IApplicationState } from '../../types/redux';

export function selectIsInfrastructureOnMapEnabled(state: IApplicationState): boolean {
  return state.infrastructure.config.enabled;
}
